<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent sp-margin__bottom-x2">
      {{ 'BUYERS.TOGGLE_BLOCK_BY_ADMIN_TITLE' | translate }}
    </h3>

    <p class="sp-color__primary sp-margin__bottom-x2">
      {{ 'BUYERS.TOGGLE_BLOCK_BY_ADMIN_DESCRIPTION' | translate }}
    </p>

    <div class="sp-color__primary sp-margin__bottom-x2">
      {{ 'BUYERS.IS_BLOCKED_DESC' | translate }}:
      <div
        class="sp-row__align"
        [ngClass]="buyer?.blocked_by_admin ? 'sp-color__warn' : 'sp-color__green'">
        {{ buyer?.blocked_by_admin ? ('BUYERS.STATUS_BLOCKED' | translate) : ('BUYERS.STATUS_ACTIVE' | translate) }}
        <mat-icon
          class="sp-margin__left-x1"
          [ngClass]="buyer?.blocked_by_admin ? 'sp-color__warn' : 'sp-color__green'">
          {{ buyer?.blocked_by_admin ? 'block' : 'check_circle' }}
        </mat-icon>
      </div>
    </div>

    <p
      *ngIf="is_toggle_changed"
      class="sp-color__primary sp-margin__bottom-x2 sp-color__warn">
      {{
        is_toggle_checked
          ? ('BUYERS.TOGGLE_BLOCK_WARNING_DESCRIPTION' | translate)
          : ('BUYERS.TOGGLE_UNBLOCK_WARNING_DESCRIPTION' | translate)
      }}
    </p>

    <div class="sp-margin__bottom">
      <mat-slide-toggle
        [checked]="buyer?.blocked_by_admin"
        (change)="onToggleChange()"
        color="primary"
        class="sp-padding__x2">
        {{ 'BUYERS.TOGGLE_BLOCK_CTA' | translate }}
      </mat-slide-toggle>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [is_disabled]="!is_toggle_changed || is_set_block_running"
        [is_spinner_visible]="is_set_block_running"
        [cta]="'GENERAL.CONFIRM_CTA'"
        (button_click)="onConfirmClick()"></app-shared-button>
    </div>
  </div>
</div>
